<template>
  <div class="route-characteristics">
    <a-empty
      v-if="!parts.length"
      class="route-characteristics__empty"
      description="Nenhuma característica encontrada."
    />

    <div v-else class="route-characteristics__row">
      <a-icon type="profile" class="route-characteristics__row-icon" />

      <span class="route-characteristics__info">
        <template v-for="(part, index) in parts">
          <span
            v-if="index > 0"
            :key="`sep-${index}`"
            class="route-characteristics__separator"
          >
            •
          </span>
          <span :key="index">
            <span class="route-characteristics__label">{{ part.label }}</span>
            {{ part.value }}
          </span>
        </template>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "FreightTableRouteCharacteristics",
  props: {
    operacao: {
      type: String,
      default: "",
    },
    processo: {
      type: String,
      default: "",
    },
  },
  computed: {
    parts() {
      const parts = [];

      if (this.operacao) {
        parts.push({ label: "Tipo de operação:", value: this.operacao });
      }

      if (this.processo) {
        parts.push({ label: "Tipo de processo:", value: this.processo });
      }

      return parts;
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.route-characteristics {
  &__empty {
    display: block;
    padding: 24px;
    text-align: center;
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #fff;
    border: 1px solid @color-bg-subtle;
    border-radius: 8px;
    padding: 12px 16px;
  }

  &__row-icon {
    color: @color-primary;
    flex-shrink: 0;
  }

  &__info {
    font-size: 14px;
    color: @color-text-dark;
    min-width: 0;
  }

  &__label {
    color: @color-text-light;
  }

  &__separator {
    color: @color-text-muted;
    margin: 0 6px;
  }
}
</style>
